/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");


const pop = require('components/base/pop/pop');

const plugMixin = {
	data(){
		return {
	    isWechat: /micromessenger/.test(navigator.userAgent.toLowerCase()),
	    iOS: /ip(hone|ad|od)/.test(navigator.userAgent.toLowerCase()),
	    android : /android/.test(navigator.userAgent.toLowerCase())
		}
	},
	components:{
		pop
	},
	methods:{
		showDownpop(){
				this.$refs.popsdown.show();
		},
		downApp() {
        var url = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.chargerlink.teslife&g_f=991653';
        if (!this.isWechat) {
          if (this.iOS) {
            url = 'https://itunes.apple.com/us/app/id824143208';
          } else if (this.android) {
            url = 'http://www.chargerlink.com/files/android/chargerlink.apk';
          }
        }
        window.location.href = url;
      }
	},
	computed:{
			startHalf(){
			let _s = ''+this.spotData.score;
			return (typeof _s.split(".")[1] != 'undefined') && (_s.split(".")[1]*1>0)
	}
	}
}

module.exports = plugMixin;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/preview/plug/plugDetail/plugMixin.js